import { SolRouteId } from '@sol/components';

export class PrototypeRouteId {
  // Apps (each prototype is a "SolApp")
  public static readonly app_prototype: SolRouteId = '';
  public static readonly app_example_dashboard: SolRouteId = 'example-dashboard';

  // Home
  public static readonly home: SolRouteId = 'home';

  // Dashboard prototype - group routes (used as navbar group headers, redirect to first child)
  public static readonly dashboard_platform: SolRouteId = 'example-dashboard/platform';
  public static readonly dashboard_platform_insights: SolRouteId = 'example-dashboard/platform-insights';
  public static readonly dashboard_admin_resources: SolRouteId = 'example-dashboard/admin-resources';

  // Dashboard prototype pages
  public static readonly dashboard_view: SolRouteId = 'example-dashboard/dashboard';
  public static readonly reports: SolRouteId = 'example-dashboard/reports';
  public static readonly reports_list: SolRouteId = 'example-dashboard/reports/generated';
  public static readonly reports_templates: SolRouteId = 'example-dashboard/reports/templates';

  // Dashboard prototype - partner pages
  public static readonly dashboard_partner_resources: SolRouteId = 'example-dashboard/partner-resources';
  public static readonly dashboard_partner_dashboards: SolRouteId = 'example-dashboard/partner-resources/dashboards';

  // Dashboard prototype - admin pages
  public static readonly dashboard_admin_resources_dashboards: SolRouteId =
    'example-dashboard/admin-resources/resources';
  public static readonly dashboard_admin_resources_reports: SolRouteId = 'example-dashboard/admin-resources/reports';
  public static readonly dashboards_overview: SolRouteId = 'example-dashboard/admin-resources/dashboards';
  public static readonly dashboards_definitions: SolRouteId = 'example-dashboard/admin-resources/definitions';
  public static readonly dashboard_admin_data_sources: SolRouteId = 'example-dashboard/admin-resources/data-sources';
  public static readonly dashboard_admin_widgets: SolRouteId = 'example-dashboard/admin-resources/widgets';
  public static readonly dashboard_admin_reports: SolRouteId = 'example-dashboard/admin-resources/reports/generated';
  public static readonly dashboard_admin_templates: SolRouteId = 'example-dashboard/admin-resources/reports/templates';

  // Dashboard prototype - admin access rules
  public static readonly dashboard_admin_access_rules: SolRouteId = 'example-dashboard/admin-resources/access-rules';

  // Billing prototype
  public static readonly app_billing: SolRouteId = 'billing';

  // Billing - group routes (used as navbar group headers, redirect to first child)
  public static readonly billing_partner: SolRouteId = 'billing/partner';
  public static readonly billing_partner_usage: SolRouteId = 'billing/partner-usage';
  public static readonly billing_admin_usage: SolRouteId = 'billing/admin-usage';

  // Billing - page routes
  public static readonly billing_partner_dashboard: SolRouteId = 'billing/partner/dashboard';
  public static readonly billing_partner_scope: SolRouteId = 'billing/partner/scope';

  // Billing - Usage tab parents (redirect to first tab child, shown in navbar with tabs)
  public static readonly billing_partner_usage_billing: SolRouteId = 'billing/partner-usage/billing';
  public static readonly billing_admin_usage_billing: SolRouteId = 'billing/admin-usage/billing';

  // Billing - Usage tab pages
  public static readonly billing_partner_usage_billing_overview: SolRouteId = 'billing/partner-usage/billing/overview';
  public static readonly billing_partner_usage_breakdown: SolRouteId = 'billing/partner-usage/breakdown';
  public static readonly billing_admin_usage_billing_overview: SolRouteId = 'billing/admin-usage/billing/overview';
  public static readonly billing_admin_usage_breakdown: SolRouteId = 'billing/admin-usage/breakdown';

  // Credentials v2 prototype
  public static readonly app_credentials_v2: SolRouteId = 'credentials-v2';

  // Credentials v2 - group routes (navbar group headers, redirect to first child)
  public static readonly credentials_v2_drp: SolRouteId = 'credentials-v2/drp';

  // Account
  public static readonly account_section1: SolRouteId = 'account-section1';
  public static readonly account_preferences: SolRouteId = 'preferences';
  public static readonly account_section2: SolRouteId = 'account-section2';
  public static readonly account_logout: SolRouteId = 'logout';

  // Credentials v2 - page routes
  public static readonly credentials_v2_credentials: SolRouteId = 'credentials-v2/drp/exposed-accounts';
  public static readonly credentials_v2_credential_detail: SolRouteId = 'credentials-v2/drp/exposed-accounts/detail';
  public static readonly credentials_v2_credential_detail_overview: SolRouteId =
    'credentials-v2/drp/exposed-accounts/detail/overview';
  public static readonly credentials_v2_credential_detail_scoring: SolRouteId =
    'credentials-v2/drp/exposed-accounts/detail/scoring';
  public static readonly credentials_v2_credential_detail_activity: SolRouteId =
    'credentials-v2/drp/exposed-accounts/detail/activity';
  public static readonly credentials_v2_cookies: SolRouteId = 'credentials-v2/drp/exposed-cookies';
  public static readonly credentials_v2_cookie_detail: SolRouteId = 'credentials-v2/drp/exposed-cookies/detail';
  public static readonly credentials_v2_cookie_detail_overview: SolRouteId =
    'credentials-v2/drp/exposed-cookies/detail/overview';
  public static readonly credentials_v2_cookie_detail_scoring: SolRouteId =
    'credentials-v2/drp/exposed-cookies/detail/scoring';
  public static readonly credentials_v2_cookie_detail_activity: SolRouteId =
    'credentials-v2/drp/exposed-cookies/detail/activity';
  public static readonly credentials_v2_exposures: SolRouteId = 'credentials-v2/drp/exposure-artifacts';
  public static readonly credentials_v2_exposure_detail: SolRouteId = 'credentials-v2/drp/exposure-artifacts/detail';
  public static readonly credentials_v2_exposure_detail_overview: SolRouteId =
    'credentials-v2/drp/exposure-artifacts/detail/overview';
  public static readonly credentials_v2_exposure_detail_scoring: SolRouteId =
    'credentials-v2/drp/exposure-artifacts/detail/scoring';
  public static readonly credentials_v2_exposure_detail_activity: SolRouteId =
    'credentials-v2/drp/exposure-artifacts/detail/activity';

  // Cyberflex prototype
  public static readonly app_cyberflex: SolRouteId = 'cyberflex';

  // Cyberflex - group routes (navbar group headers, redirect to first child)
  public static readonly cyberflex_requests: SolRouteId = 'cyberflex/requests';
  public static readonly cyberflex_assets: SolRouteId = 'cyberflex/assets';

  // Cyberflex - Requests page routes
  public static readonly cyberflex_requests_overview: SolRouteId = 'cyberflex/requests/overview';
  public static readonly cyberflex_requests_engagement: SolRouteId = 'cyberflex/requests/engagement';

  // Cyberflex - Request detail routes
  public static readonly cyberflex_requests_detail: SolRouteId = 'cyberflex/requests/:id';
  public static readonly cyberflex_requests_detail_overview: SolRouteId = 'cyberflex/requests/:id/overview';
  public static readonly cyberflex_requests_detail_comments: SolRouteId = 'cyberflex/requests/:id/comments';
  public static readonly cyberflex_requests_detail_attachments: SolRouteId = 'cyberflex/requests/:id/attachments';
  public static readonly cyberflex_requests_detail_activity: SolRouteId = 'cyberflex/requests/:id/activity';

  // Cyberflex - Asset page routes
  public static readonly cyberflex_assets_domains: SolRouteId = 'cyberflex/assets/domains';
  public static readonly cyberflex_assets_hosts: SolRouteId = 'cyberflex/assets/hosts';
  public static readonly cyberflex_assets_websites: SolRouteId = 'cyberflex/assets/websites';

  // Asset Inventory prototype
  public static readonly app_asset_inventory: SolRouteId = 'asset-inventory';
  public static readonly asset_inventory_assets: SolRouteId = 'asset-inventory/assets';

  // DEV-18073 Compliance prototype — the whole left nav of the current product
  // is mirrored, so most of these routes land on a placeholder page. Only
  // findings/compliance is live.
  public static readonly app_dev_18073_compliance: SolRouteId = 'dev-18073-compliance';
  public static readonly dev_18073_compliance_asset_groups: SolRouteId = 'dev-18073-compliance/asset-groups';
  public static readonly dev_18073_compliance_assets: SolRouteId = 'dev-18073-compliance/assets';
  public static readonly dev_18073_compliance_findings: SolRouteId = 'dev-18073-compliance/findings';
  public static readonly dev_18073_compliance_vulnerabilities: SolRouteId =
    'dev-18073-compliance/findings/vulnerabilities';
  public static readonly dev_18073_compliance_informational: SolRouteId = 'dev-18073-compliance/findings/informational';
  public static readonly dev_18073_compliance_compliance: SolRouteId = 'dev-18073-compliance/findings/compliance';
  public static readonly dev_18073_compliance_catalog: SolRouteId = 'dev-18073-compliance/findings/catalog';
  public static readonly dev_18073_compliance_configuration: SolRouteId = 'dev-18073-compliance/configuration';
  // Configuration children — mirrors the current product's submenu. Only
  // Workflows is live (the wizard carries this ticket's Compliance step).
  public static readonly dev_18073_compliance_scan_configurations: SolRouteId =
    'dev-18073-compliance/configuration/scan-configurations';
  public static readonly dev_18073_compliance_rc_scanners: SolRouteId =
    'dev-18073-compliance/configuration/rc-scanners';
  public static readonly dev_18073_compliance_scan_policies: SolRouteId =
    'dev-18073-compliance/configuration/scan-policies';
  public static readonly dev_18073_compliance_view_templates: SolRouteId =
    'dev-18073-compliance/configuration/view-templates';
  public static readonly dev_18073_compliance_credentials: SolRouteId =
    'dev-18073-compliance/configuration/credentials';
  public static readonly dev_18073_compliance_integrations: SolRouteId =
    'dev-18073-compliance/configuration/integrations';
  public static readonly dev_18073_compliance_notification_settings: SolRouteId =
    'dev-18073-compliance/configuration/notification-settings';
  public static readonly dev_18073_compliance_workflows: SolRouteId = 'dev-18073-compliance/configuration/workflows';
  public static readonly dev_18073_compliance_workflow_new: SolRouteId =
    'dev-18073-compliance/configuration/workflows/new';
  public static readonly dev_18073_compliance_automation: SolRouteId = 'dev-18073-compliance/automation';
  public static readonly dev_18073_compliance_scans: SolRouteId = 'dev-18073-compliance/scans';
  public static readonly dev_18073_compliance_report_library: SolRouteId = 'dev-18073-compliance/report-library';
  public static readonly dev_18073_compliance_tags: SolRouteId = 'dev-18073-compliance/tags';
  public static readonly dev_18073_compliance_subscriptions: SolRouteId = 'dev-18073-compliance/subscriptions';
  public static readonly dev_18073_compliance_consumption: SolRouteId = 'dev-18073-compliance/consumption';
  public static readonly dev_18073_compliance_appliances: SolRouteId = 'dev-18073-compliance/appliances';

  // Engagement requests finetuning prototype
  public static readonly app_engagement_requests_finetuning: SolRouteId = 'engagement-requests-finetuning';
  public static readonly engagement_requests_finetuning_page: SolRouteId = 'engagement-requests-finetuning/page';

  // Observation attachments prototype
  public static readonly app_observation_attachments: SolRouteId = 'observation-attachments';
  public static readonly observation_attachments_list: SolRouteId = 'observation-attachments/observations';

  // Legacy observation attachments prototype (dialog flow)
  public static readonly app_legacy_observation_attachments: SolRouteId = 'legacy-observation-attachments';
  public static readonly legacy_observation_attachments_launcher: SolRouteId =
    'legacy-observation-attachments/launcher';

  // Finding templates prototype
  public static readonly app_finding_templates: SolRouteId = 'finding-templates';
  public static readonly finding_templates_findings: SolRouteId = 'finding-templates/findings';
  public static readonly finding_templates_vulnerabilities: SolRouteId = 'finding-templates/findings/vulnerabilities';
  public static readonly finding_templates_informational: SolRouteId = 'finding-templates/findings/informational';
  public static readonly finding_templates_compliance: SolRouteId = 'finding-templates/findings/compliance';
  public static readonly finding_templates_list: SolRouteId = 'finding-templates/findings/templates';
  public static readonly finding_templates_catalog: SolRouteId = 'finding-templates/findings/catalog';

  // DEV-18689 — Ghostlab matches prototype.
  // One canvas that puts the customer (read) and GhostLabs (edit) finding detail
  // panels side by side. Baseline only: the two panels exactly as Portal shows
  // them today, no improvements.
  public static readonly app_dev_18689_ghostlab_matches: SolRouteId = 'dev-18689-ghostlab-matches';
  public static readonly dev_18689_ghostlab_matches_finding: SolRouteId = 'dev-18689-ghostlab-matches/finding';

  // Project North Star prototype
  public static readonly app_project_north_star: SolRouteId = 'project-north-star';
  public static readonly project_north_star_integrated_people_view: SolRouteId =
    'project-north-star/integrated-people-view';
  public static readonly project_north_star_person_detail: SolRouteId = 'project-north-star/integrated-people-view/:id';

  // Vulnerability catalog prototype
  public static readonly app_vulnerability_catalog: SolRouteId = 'vulnerability-catalog';
  public static readonly vulnerability_catalog_dashboard: SolRouteId = 'vulnerability-catalog/dashboard';
  public static readonly vulnerability_catalog_list: SolRouteId = 'vulnerability-catalog/vulnerabilities';
  public static readonly vulnerability_catalog_detail: SolRouteId = 'vulnerability-catalog/vulnerabilities/:id';

  // Dashboard banners prototype (issue 9194)
  public static readonly app_dashboard_banners: SolRouteId = 'dashboard-banners';
  public static readonly dashboard_banners_dashboard: SolRouteId = 'dashboard-banners/dashboard';
  public static readonly dashboard_banners_admin: SolRouteId = 'dashboard-banners/administration';

  // Finding verification flow prototype — the customer and pentester views of one finding set
  public static readonly app_finding_verification_flow: SolRouteId = 'finding-verification-flow';
  public static readonly finding_verification_flow_customer: SolRouteId = 'finding-verification-flow/customer';
  public static readonly finding_verification_flow_pentester: SolRouteId = 'finding-verification-flow/pentester';
  // One detail page, reached from either tab, so each tab owns a route to it and the breadcrumb
  // reads correctly whichever view you came from.
  public static readonly finding_verification_flow_customer_detail: SolRouteId =
    'finding-verification-flow/customer/:id';
  public static readonly finding_verification_flow_pentester_detail: SolRouteId =
    'finding-verification-flow/pentester/:id';
  // Engagements: the pentester's second section, mirroring the platform's engagements/* routes.
  public static readonly finding_verification_flow_engagements: SolRouteId = 'finding-verification-flow/engagements';
  public static readonly finding_verification_flow_engagements_overview: SolRouteId =
    'finding-verification-flow/engagements/overview';
  public static readonly finding_verification_flow_engagements_list: SolRouteId =
    'finding-verification-flow/engagements/list';
  public static readonly finding_verification_flow_engagements_accounts: SolRouteId =
    'finding-verification-flow/engagements/accounts';
  public static readonly finding_verification_flow_engagement_detail: SolRouteId =
    'finding-verification-flow/engagements/list/:id';

  // Threat Explorer prototype (monitor software lists, epic &293)
  public static readonly app_threat_explorer: SolRouteId = 'threat-explorer';
  public static readonly threat_explorer_lists: SolRouteId = 'threat-explorer/lists';
  public static readonly threat_explorer_list: SolRouteId = 'threat-explorer/lists/:id';
  public static readonly threat_explorer_list_detail: SolRouteId = 'threat-explorer/lists/:id/overview';
  public static readonly threat_explorer_list_software: SolRouteId = 'threat-explorer/lists/:id/technologies';
  public static readonly threat_explorer_software_detail: SolRouteId =
    'threat-explorer/lists/:id/technologies/:softwareId';
  public static readonly threat_explorer_software_overview: SolRouteId =
    'threat-explorer/lists/:id/technologies/:softwareId/overview';
  public static readonly threat_explorer_software_activity: SolRouteId =
    'threat-explorer/lists/:id/technologies/:softwareId/activity';
  public static readonly threat_explorer_list_vulnerabilities: SolRouteId = 'threat-explorer/lists/:id/vulnerabilities';
  public static readonly threat_explorer_vulnerability_detail: SolRouteId =
    'threat-explorer/lists/:id/vulnerabilities/:cveId';
  public static readonly threat_explorer_list_activity: SolRouteId = 'threat-explorer/lists/:id/activity';
  public static readonly threat_explorer_list_notifications: SolRouteId = 'threat-explorer/lists/:id/notifications';
  public static readonly threat_explorer_platform_notifications: SolRouteId = 'threat-explorer/platform-notifications';

  // Web Content v2 prototype
  public static readonly app_asset_details: SolRouteId = 'asset-details';
  public static readonly asset_details_assets: SolRouteId = 'asset-details/assets';
  public static readonly asset_details_certificates: SolRouteId = 'asset-details/certificates';
  public static readonly asset_details_certificate: SolRouteId = 'asset-details/certificates/:id';
  public static readonly asset_details_certificate_overview: SolRouteId = 'asset-details/certificates/:id/overview';
  public static readonly asset_details_certificate_findings: SolRouteId = 'asset-details/certificates/:id/findings';
  public static readonly asset_details_certificate_scoring: SolRouteId = 'asset-details/certificates/:id/scoring';
  public static readonly asset_details_domain_discovery: SolRouteId = 'asset-details/domain-discovery';
  public static readonly asset_details_domain_candidate: SolRouteId = 'asset-details/domain-discovery/:id';
  public static readonly asset_details_domain_candidate_overview: SolRouteId =
    'asset-details/domain-discovery/:id/overview';
  public static readonly asset_details_domain_candidate_activity: SolRouteId =
    'asset-details/domain-discovery/:id/activity';
  public static readonly asset_details_domains: SolRouteId = 'asset-details/domains';
  public static readonly asset_details_domain: SolRouteId = 'asset-details/domains/:id';
  public static readonly asset_details_domain_overview: SolRouteId = 'asset-details/domains/:id/overview';
  public static readonly asset_details_domain_findings: SolRouteId = 'asset-details/domains/:id/findings';
  public static readonly asset_details_domain_scoring: SolRouteId = 'asset-details/domains/:id/scoring';
  public static readonly asset_details_hosts: SolRouteId = 'asset-details/hosts';
  public static readonly asset_details_host: SolRouteId = 'asset-details/hosts/:id';
  public static readonly asset_details_host_overview: SolRouteId = 'asset-details/hosts/:id/overview';
  public static readonly asset_details_host_findings: SolRouteId = 'asset-details/hosts/:id/findings';
  public static readonly asset_details_host_scoring: SolRouteId = 'asset-details/hosts/:id/scoring';
  public static readonly asset_details_host_scan_history: SolRouteId = 'asset-details/hosts/:id/scan-history';
  public static readonly asset_details_websites: SolRouteId = 'asset-details/websites';
  public static readonly asset_details_website: SolRouteId = 'asset-details/websites/:id';
  public static readonly asset_details_website_overview: SolRouteId = 'asset-details/websites/:id/overview';
  public static readonly asset_details_website_findings: SolRouteId = 'asset-details/websites/:id/findings';
  public static readonly asset_details_website_scoring: SolRouteId = 'asset-details/websites/:id/scoring';
  public static readonly app_webcontent_v2: SolRouteId = 'webcontent-v2';
  public static readonly webcontent_v2_drp: SolRouteId = 'webcontent-v2/drp';
  public static readonly webcontent_v2_dark_web: SolRouteId = 'webcontent-v2/drp/dark-web';
  public static readonly webcontent_v2_dark_web_detail: SolRouteId = 'webcontent-v2/drp/dark-web/:id';
  public static readonly webcontent_v2_dark_web_detail_overview: SolRouteId = 'webcontent-v2/drp/dark-web/:id/overview';
  public static readonly webcontent_v2_dark_web_detail_activity: SolRouteId = 'webcontent-v2/drp/dark-web/:id/activity';
  public static readonly webcontent_v2_data_leakage: SolRouteId = 'webcontent-v2/drp/data-leakage';
  public static readonly webcontent_v2_data_leakage_detail: SolRouteId = 'webcontent-v2/drp/data-leakage/:id';
  public static readonly webcontent_v2_data_leakage_detail_overview: SolRouteId =
    'webcontent-v2/drp/data-leakage/:id/overview';
  public static readonly webcontent_v2_data_leakage_detail_activity: SolRouteId =
    'webcontent-v2/drp/data-leakage/:id/activity';
  public static readonly webcontent_v2_social_media: SolRouteId = 'webcontent-v2/drp/social-media';
  public static readonly webcontent_v2_social_media_detail: SolRouteId = 'webcontent-v2/drp/social-media/:id';
  public static readonly webcontent_v2_social_media_detail_overview: SolRouteId =
    'webcontent-v2/drp/social-media/:id/overview';
  public static readonly webcontent_v2_social_media_detail_activity: SolRouteId =
    'webcontent-v2/drp/social-media/:id/activity';
  public static readonly webcontent_v2_mobile_apps: SolRouteId = 'webcontent-v2/drp/mobile-apps';
  public static readonly webcontent_v2_mobile_app_detail: SolRouteId = 'webcontent-v2/drp/mobile-apps/:id';
  public static readonly webcontent_v2_mobile_app_detail_overview: SolRouteId =
    'webcontent-v2/drp/mobile-apps/:id/overview';
  public static readonly webcontent_v2_mobile_app_detail_activity: SolRouteId =
    'webcontent-v2/drp/mobile-apps/:id/activity';

  // Workflows prototype
  public static readonly app_workflows: SolRouteId = 'workflows';
  public static readonly workflows_tracker: SolRouteId = 'workflows/tracker';
  public static readonly workflows_drp: SolRouteId = 'workflows/drp';
  public static readonly workflows_dark_web: SolRouteId = 'workflows/drp/dark-web';
  public static readonly workflows_assets: SolRouteId = 'workflows/assets';
  public static readonly workflows_domain_discovery: SolRouteId = 'workflows/assets/domain-discovery';

  // Module read-only banner prototype
  public static readonly app_module_read_only_banner: SolRouteId = 'module-read-only-banner';
  public static readonly module_read_only_banner_drp: SolRouteId = 'module-read-only-banner/drp';
  public static readonly module_read_only_banner_exposed_accounts: SolRouteId =
    'module-read-only-banner/drp/exposed-accounts';

  // Redirect duplicates prototype — a light copy of the tracker list, panel and observation page
  public static readonly app_redirect_duplicates: SolRouteId = 'redirect-duplicates';
  public static readonly redirect_duplicates_observation: SolRouteId = 'redirect-duplicates/observation/:id';
  // A light copy of the asset-details redesign's website and domain pages, each list opening one sample asset
  public static readonly redirect_duplicates_websites: SolRouteId = 'redirect-duplicates/websites';
  public static readonly redirect_duplicates_website: SolRouteId = 'redirect-duplicates/websites/:id';
  public static readonly redirect_duplicates_website_overview: SolRouteId = 'redirect-duplicates/websites/:id/overview';
  public static readonly redirect_duplicates_website_findings: SolRouteId = 'redirect-duplicates/websites/:id/findings';
  public static readonly redirect_duplicates_domains: SolRouteId = 'redirect-duplicates/domains';
  public static readonly redirect_duplicates_domain: SolRouteId = 'redirect-duplicates/domains/:id';
  public static readonly redirect_duplicates_domain_overview: SolRouteId = 'redirect-duplicates/domains/:id/overview';
  public static readonly redirect_duplicates_domain_findings: SolRouteId = 'redirect-duplicates/domains/:id/findings';

  // Annotation notes prototype — light copies of the tracker and ATP exposed account panel and page
  public static readonly app_annotation_notes: SolRouteId = 'annotation-notes';
  public static readonly annotation_notes_tracker: SolRouteId = 'annotation-notes/tracker';
  public static readonly annotation_notes_tracker_overview: SolRouteId = 'annotation-notes/tracker/:id/overview';
  public static readonly annotation_notes_exposed_accounts: SolRouteId = 'annotation-notes/atp/exposed-accounts';
  public static readonly annotation_notes_exposed_account_overview: SolRouteId =
    'annotation-notes/atp/exposed-accounts/:id/overview';

  // Subscope hierarchy prototype
  public static readonly app_subscope_hierarchy: SolRouteId = 'subscope-hierarchy';
  public static readonly subscope_hierarchy_breadcrumb: SolRouteId = 'subscope-hierarchy/breadcrumb';
  public static readonly subscope_hierarchy_scope: SolRouteId = 'subscope-hierarchy/scope';
  public static readonly subscope_hierarchy_scope_overview: SolRouteId = 'subscope-hierarchy/scope/overview';
  public static readonly subscope_hierarchy_scope_subscopes: SolRouteId = 'subscope-hierarchy/scope/subscopes';
  public static readonly subscope_hierarchy_scope_seeds: SolRouteId = 'subscope-hierarchy/scope/seeds';
}
